import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import styled, { keyframes } from 'styled-components';

const FormContainer = styled.form`
  width: 100%;
`;

const DonationSummary = styled.div`
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-family: var(--font-sans);
  font-size: 1.1rem;
  color: var(--color-text);
  border: 1px solid rgba(0,0,0,0.05);

  strong {
    color: var(--color-primary-blue);
    font-weight: 600;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 1s linear infinite;
`;

const ErrorMessage = styled.div`
  background: #fee2e2;
  color: #dc2626;
  padding: 12px;
  border-radius: 8px;
  margin-top: 16px;
  font-size: 0.9rem;
  font-weight: 500;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 16px;
  background: var(--color-primary-blue);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
  transition: all 0.2s;

  &:hover {
    background: var(--color-accent);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const CheckoutForm = ({ amount }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsProcessing(true);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/payment/success`,
      },
    });

    if (result.error) {
      setMessage(result.error.message);
    }

    setIsProcessing(false);
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <DonationSummary>
        Total to donate: <strong>CHF {Number(amount).toFixed(2)}</strong>
      </DonationSummary>

      <PaymentElement />

      {message && <ErrorMessage>{message}</ErrorMessage>}

      <SubmitButton type="submit" disabled={!stripe || isProcessing}>
        {isProcessing ? (
          <>
            <Spinner /> Processing...
          </>
        ) : (
          'Complete Payment'
        )}
      </SubmitButton>
    </FormContainer>
  );
};

export default CheckoutForm;